module.exports = __webpack_public_path__ + "static/media/multiples.011d2777.svg";